import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { inputParseFn } from '../../../../../common/helpers/inputs';
import Input from '../../../../../common/input';
import { useTimeout } from '../../../../helpers';


const InventoryInput = ({ row, assignmentValues, unallocatedInventory }) => {
  const [showCorrectionMessage, setShowCorrectionMessage] = useState(false);
  const hideCorrectionMessageByTimeout = useTimeout(() => setShowCorrectionMessage(false), 2000);

  const normalize = (value, previousValue, nextValues, previousValues) => {
    // previousValue always comes as 'undefined' from redux-form lib for some reason
    // so getting the previous value from all previous values instead.
    // could be because there's deprecated 'refs' field used for getting the value, but not sure
    // https://github.com/redux-form/redux-form/blob/v6.8.0/src/createField.js#L79
    const previousOrZero = get(previousValues, ['assignments', row.original.ownerId, 'inventory'], 0);

    if (value <= unallocatedInventory + previousOrZero) {
      return value;
    }

    setShowCorrectionMessage(true);
    hideCorrectionMessageByTimeout();

    return unallocatedInventory + previousOrZero;
  };

  const isAssignmentDisabled = !get(assignmentValues, [row.original.ownerId, 'enabled'], false);

  return (
    <div className="u-position-relative c-input__error_narrow-centered c-input__error_fixed">
      <Input
        type="number"
        className="c-input"
        name={`assignments.${row.original.ownerId}.inventory`}
        placeholder="Inventory"
        parse={inputParseFn}
        disabled={isAssignmentDisabled}
        normalize={normalize}
        min={0}
      />
      <div className="c-input-error-message" display-if={showCorrectionMessage}>
        Over assigned; assigned inventory corrected to your remaining inventory.
      </div>
    </div>
  );
};

InventoryInput.propTypes = {
  row: PropTypes.shape({ original: PropTypes.shape({ ownerId: PropTypes.string }) }).isRequired,
  assignmentValues: PropTypes.shape({}).isRequired,
  unallocatedInventory: PropTypes.number.isRequired,
};

export default InventoryInput;
